export const environment = {
  production: true,
  NG_APP_FIREBASE_APIKEY: "AIzaSyBRsJtUHTHbLbaEqQ4cqFWw2tHJXCQd7g0",
  NG_APP_FIREBASE_AUTHDOMAIN: "personal-website-530c9.firebaseapp.com",
  NG_APP_FIREBASE_DATABASEURL: "https://personal-website-530c9-default-rtdb.europe-west1.firebasedatabase.app",
  NG_APP_FIREBASE_PROJECTID: "personal-website-530c9",
  NG_APP_FIREBASE_STORAGEBUCKET: "personal-website-530c9.firebasestorage.app",
  NG_APP_FIREBASE_MESSAGINGSENDERID: "204509415615",
  NG_APP_FIREBASE_APPID: "1:204509415615:web:608019ebd72f4251aede0a",
  NG_APP_FIREBASE_MEASUREMENTID: "G-QXS7R6WXK4"
};
